// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1R_gW","content":"LoadingAlert_content__22P8S"};